import { useMemo } from 'react';
import type { PortfolioReport } from '../types';
import {
  type EnrichedHolding,
  enrichHoldings,
} from '../utils/portfolioRevampBuilders';

export function useEnrichedHoldings(
  report: PortfolioReport,
): EnrichedHolding[] {
  // biome-ignore lint/correctness/useExhaustiveDependencies: match original memo — only re-enrich when holdings or market value change
  return useMemo(
    () => enrichHoldings(report),
    [report.holdings, report.marketValueCents],
  );
}
